import api from './axios';

// Upload transcript file and get AI analysis
export const uploadTranscript = async (file, metadata = {}) => {
  try {
    const formData = new FormData();
    formData.append('transcript', file);
    
    // Add company and contact metadata if provided
    if (metadata.companyName) {
      formData.append('companyName', metadata.companyName);
    }
    if (metadata.contactNames) {
      formData.append('contactNames', JSON.stringify(metadata.contactNames));
    }

    const response = await api.post('/transcripts/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Upload transcript error:', error);
    throw new Error(error.response?.data?.message || 'Failed to upload transcript');
  }
};

// Get all transcripts for the current user
export const getTranscripts = async (params = {}) => {
  try {
    const response = await api.get('/transcripts', { params });
    return response.data;
  } catch (error) {
    console.error('Get transcripts error:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch transcripts');
  }
};

// Get specific transcript by ID
export const getTranscriptById = async (id) => {
  try {
    const response = await api.get(`/transcripts/${id}`);
    return response.data;
  } catch (error) {
    console.error('Get transcript error:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch transcript');
  }
};

// Update transcript metadata (company and contact information)
export const updateTranscriptMetadata = async (id, metadata) => {
  try {
    console.log('🔄 updateTranscriptMetadata called with:', { id, metadata });
    console.log('🔄 Making PUT request to:', `/transcripts/${id}/metadata`);
    
    const response = await api.put(`/transcripts/${id}/metadata`, metadata);
    
    console.log(' updateTranscriptMetadata response:', response.data);
    return response.data;
  } catch (error) {
    console.error(' Update transcript metadata error:', error);
    console.error(' Error response:', error.response?.data);
    console.error(' Error status:', error.response?.status);
    throw new Error(error.response?.data?.message || 'Failed to update transcript metadata');
  }
};

// Get cached transcript
export const getCachedTranscript = async (id) => {
  try {
    console.log('🔄 getCachedTranscript called with:', { id });
    console.log('🔄 Making GET request to:', `/transcripts/${id}/cached`);
    
    const response = await api.get(`/transcripts/${id}/cached`);
    
    console.log(' getCachedTranscript response:', response.data);
    return response.data.data.transcript;
  } catch (error) {
    console.error(' Get cached transcript error:', error);
    console.error(' Error response:', error.response?.data);
    console.error(' Error status:', error.response?.status);
    throw new Error(error.response?.data?.message || 'Failed to get cached transcript');
  }
};

// Get cached analysis results
export const getCachedAnalysis = async (id) => {
  try {
    console.log('🔄 getCachedAnalysis called with:', { id });
    console.log('🔄 Making GET request to:', `/transcripts/${id}/cached-analysis`);
    
    const response = await api.get(`/transcripts/${id}/cached-analysis`);
    
    console.log(' getCachedAnalysis response:', response.data);
    return response.data.data;
  } catch (error) {
    console.error(' Get cached analysis error:', error);
    console.error(' Error response:', error.response?.data);
    console.error(' Error status:', error.response?.status);
    throw new Error(error.response?.data?.message || 'Failed to get cached analysis');
  }
};

// Start transcript analysis manually
export const startTranscriptAnalysis = async (id) => {
  try {
    console.log('🔄 startTranscriptAnalysis called with:', { id });
    console.log('🔄 Making POST request to:', `/transcripts/${id}/analyze`);
    
    const response = await api.post(`/transcripts/${id}/analyze`);
    
    console.log(' startTranscriptAnalysis response:', response.data);
    return response.data;
  } catch (error) {
    console.error(' Start transcript analysis error:', error);
    console.error(' Error response:', error.response?.data);
    console.error(' Error status:', error.response?.status);
    throw new Error(error.response?.data?.message || 'Failed to start transcript analysis');
  }
};

// Save transcript to database (following Compass pattern)
export const saveTranscriptToDatabase = async (id, metadata) => {
  try {
    console.log('🔄 saveTranscriptToDatabase called with:', { id, metadata });
    console.log('🔄 Making POST request to:', `/transcripts/${id}/save`);
    
    const response = await api.post(`/transcripts/${id}/save`, metadata);
    
    console.log(' saveTranscriptToDatabase response:', response.data);
    return response.data.data.transcript; // Match Compass pattern
  } catch (error) {
    console.error(' Save transcript to database error:', error);
    console.error(' Error response:', error.response?.data);
    console.error(' Error status:', error.response?.status);
    throw new Error(error.response?.data?.message || 'Failed to save transcript to database');
  }
};

// Get transcript analysis
export const getTranscriptAnalysis = async (id) => {
  try {
    const response = await api.get(`/transcripts/${id}/analysis`);
    return response.data;
  } catch (error) {
    console.error('Get analysis error:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch analysis');
  }
};

// Delete transcript
export const deleteTranscript = async (id) => {
  try {
    const response = await api.delete(`/transcripts/${id}`);
    return response.data;
  } catch (error) {
    console.error('Delete transcript error:', error);
    throw new Error(error.response?.data?.message || 'Failed to delete transcript');
  }
};

 